webpackJsonp([21],{

/***/ "/rEa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    padding: '8px 24px 24px'
  }
};
exports.styles = styles;

function ExpansionPanelDetails(props) {
  var classes = props.classes,
      children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "children", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), children);
}

ExpansionPanelDetails.propTypes =  false ? {
  /**
   * The content of the expansion panel details.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanelDetails'
})(ExpansionPanelDetails);

exports.default = _default;

/***/ }),

/***/ "6qNF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _actionTypes = __webpack_require__("EA8k");

var types = _interopRequireWildcard(_actionTypes);

var _Text = __webpack_require__("8/ml");

var _Text2 = _interopRequireDefault(_Text);

var _CloudFrontPicture = __webpack_require__("k6iV");

var _CloudFrontPicture2 = _interopRequireDefault(_CloudFrontPicture);

var _InternalLink = __webpack_require__("XSs2");

var _InternalLink2 = _interopRequireDefault(_InternalLink);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurrentHashtagWinner = function CurrentHashtagWinner() {
    var StyledCurrentHashtagWinner = _styledComponents2.default.div.withConfig({
        displayName: 'CurrentHashtagWinner__StyledCurrentHashtagWinner',
        componentId: 'sc-k8tjky-0'
    })(['\n        &.schnoffle-hashtag-winner img {\n          max-heigth: 60vh;\n          max-width: 60vw;\n        }\n\n        & .schnoffle-hashtag-winner-text {\n          margin-bottom: 2em;\n        }\n    ']);

    return _react2.default.createElement(
        StyledCurrentHashtagWinner,
        { className: 'schnoffle-hashtag-winner' },
        _react2.default.createElement(_Text2.default.Heading, {
            text: 'Gewinnerin Juni 2019 \u2665 Carina aka Kleines Farb - Tupferl',
            level: 3
        }),
        _react2.default.createElement(
            'p',
            { className: 'schnoffle-hashtag-winner-text' },
            _react2.default.createElement(
                _InternalLink2.default,
                {
                    to: {
                        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                        payload: {
                            sewpatId: 'martha',
                            patternid: 24472
                        },
                        meta: { query: { colors: '000000,ffffff,4c4c4d,5c9dc0,5174ef,5bc5c6' } }
                    }
                },
                'Dieser Entwurf\xA0'
            ),
            'des Designerst\xFCckes ',
            _react2.default.createElement(
                _InternalLink2.default,
                {
                    to: {
                        type: types.NAVIGATED_TO_SEWPAT_VIEW,
                        payload: { sewpatId: 'martha' }
                    }
                },
                '"Martha"\xA0'
            ),
            'eingereicht von ',
            _react2.default.createElement(
                'a',
                {
                    href: 'https://www.facebook.com/FarbTuepfelchen/posts/2410162472546984'
                },
                'Carina aka Kleines Farb - Tupferl'
            ),
            ', gewinnt die Junirunde des #schnoffle Hashtag Wettbewerbs #springschnoffle.'
        ),
        _react2.default.createElement(
            _InternalLink2.default,
            {
                to: {
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'martha',
                        patternid: 24472
                    },
                    meta: { query: { colors: '000000,ffffff,4c4c4d,5c9dc0,5174ef,5bc5c6' } }
                }
            },
            _react2.default.createElement(_CloudFrontPicture2.default, {
                src: 'schnoffle-gewinner-q2-19.png',
                webp: 'sschnoffle-gewinner-q2-19.webp', png: true, schnoffle: true
            })
        ),
        _react2.default.createElement(
            'p',
            null,
            'Bitte melde Dich per ',
            _react2.default.createElement(
                'a',
                {
                    href: 'mailto:wir@schnoffle.de'
                },
                'E-Mail'
            ),
            ' bei uns, damit wir uns bzgl. des gewonnenen N\xE4hpaketes austauschen k\xF6nnen.'
        )
    );
};

exports.default = CurrentHashtagWinner;

/***/ }),

/***/ "7aZE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ExpansionPanel = __webpack_require__("u49v");

var _ExpansionPanel2 = _interopRequireDefault(_ExpansionPanel);

var _ExpansionPanelDetails = __webpack_require__("nR/d");

var _ExpansionPanelDetails2 = _interopRequireDefault(_ExpansionPanelDetails);

var _ExpansionPanelSummary = __webpack_require__("OYRJ");

var _ExpansionPanelSummary2 = _interopRequireDefault(_ExpansionPanelSummary);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Heading = __webpack_require__("6GnX");

var _Heading2 = _interopRequireDefault(_Heading);

var _Icon = __webpack_require__("PlKq");

var _Icon2 = _interopRequireDefault(_Icon);

var _HorizontalDivider = __webpack_require__("SZDM");

var _HorizontalDivider2 = _interopRequireDefault(_HorizontalDivider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollapsableContainer = function CollapsableContainer(_ref) {
    var heading = _ref.heading,
        children = _ref.children,
        dense = _ref.dense;


    var StyledCollapsableContainer = _styledComponents2.default.div.withConfig({
        displayName: 'CollapsableContainer__StyledCollapsableContainer',
        componentId: 'sc-16nxzs1-0'
    })(['\n        width: 94%;\n        margin: 0 auto;\n\n        & .schnoffle-collapsable-expanded h3 {\n          padding: 0;\n          margin-left: 40%;\n          transform: translateX(-40%);\n          border-bottom: 1px dashed;\n        }\n\n        & .schnoffle-expansion-dense {\n          padding: 1em;\n        }\n\n        & .schnoffle-expansion {\n          display: block;\n        }\n    ']);

    var ExpandMoreIcon = _react2.default.createElement(_Icon2.default, {
        name: 'icon-keyboard_arrow_down', width: '1.5em',
        height: '1.5em'
    });

    return _react2.default.createElement(
        StyledCollapsableContainer,
        null,
        _react2.default.createElement(
            _ExpansionPanel2.default,
            null,
            _react2.default.createElement(
                _ExpansionPanelSummary2.default,
                {
                    expandIcon: ExpandMoreIcon,
                    classes: { expanded: 'schnoffle-collapsable-expanded' }
                },
                _react2.default.createElement(_Heading2.default, { level: 3, text: heading })
            ),
            _react2.default.createElement(
                _ExpansionPanelDetails2.default,
                { classes: dense ? { root: 'schnoffle-expansion schnoffle-expansion-dense' } : { root: 'schnoffle-expansion' } },
                children
            )
        )
    );
};

exports.default = CollapsableContainer;

/***/ }),

/***/ "8/ml":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Heading = __webpack_require__("6GnX");

var _Heading2 = _interopRequireDefault(_Heading);

var _HorizontalDivider = __webpack_require__("SZDM");

var _HorizontalDivider2 = _interopRequireDefault(_HorizontalDivider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Text = function Text(_ref) {
    var colored = _ref.colored,
        children = _ref.children,
        className = _ref.className,
        margin = _ref.margin,
        left = _ref.left;

    var OuterTextContainer = _styledComponents2.default.div.withConfig({
        displayName: 'Text__OuterTextContainer',
        componentId: 'sc-89ig1k-0'
    })(['\n        background-color: ', ';\n        margin: ', ';\n    '], function (props) {
        return colored ? props.theme.palette.secondary.A200 : 'transparent';
    }, margin || '0');

    var InnerTextContainer = _styledComponents2.default.div.withConfig({
        displayName: 'Text__InnerTextContainer',
        componentId: 'sc-89ig1k-1'
    })(['\n        max-width: 66ch;\n        padding: ', ' ', ' ', ' ', ';\n        margin: ', ';\n    '], function (props) {
        return props.theme.space[5];
    }, function (props) {
        return props.theme.space[8];
    }, function (props) {
        return props.theme.space[5];
    }, function (props) {
        return props.theme.space[10];
    }, left ? '0' : '0 auto');

    return _react2.default.createElement(
        OuterTextContainer,
        { className: className },
        _react2.default.createElement(
            InnerTextContainer,
            null,
            children
        )
    );
};

Text.Heading = _Heading2.default;
Text.Divider = _HorizontalDivider2.default;

exports.default = Text;

/***/ }),

/***/ "EXt7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _actionTypes = __webpack_require__("EA8k");

var types = _interopRequireWildcard(_actionTypes);

var _CollapsableContainer = __webpack_require__("7aZE");

var _CollapsableContainer2 = _interopRequireDefault(_CollapsableContainer);

var _Text = __webpack_require__("8/ml");

var _Text2 = _interopRequireDefault(_Text);

var _CloudFrontPicture = __webpack_require__("k6iV");

var _CloudFrontPicture2 = _interopRequireDefault(_CloudFrontPicture);

var _InternalLink = __webpack_require__("XSs2");

var _InternalLink2 = _interopRequireDefault(_InternalLink);

var _CurrentHashtagWinner = __webpack_require__("6qNF");

var _CurrentHashtagWinner2 = _interopRequireDefault(_CurrentHashtagWinner);

var _HashtagWinnerHistory = __webpack_require__("MTmj");

var _HashtagWinnerHistory2 = _interopRequireDefault(_HashtagWinnerHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hashtag = function Hashtag() {
    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            _Text2.default,
            null,
            _react2.default.createElement(_Text2.default.Heading, {
                text: 'Hashtag Jul/Aug/Sep - #herbstschnoffle',
                level: 3
            }),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                    'span',
                    {
                        className: 'schnoffle-bold' },
                    '#herbstschnoffle\xA0'
                ),
                ' Nichts ist so golden wie der Herbst? Wenn die Bl\xE4tter bunt \xFCber die Stra\xDFe wehen, dann d\xFCrfen die gedruckten Stoffe sich einreihen. Komm gern st\xF6bern und entdecke jede Menge Farbe und n\xE4h Dir Designerst\xFCcke f\xFCr den kommenden Herbst. Zeig uns Deine Modeskizze in den sozialen Medien mit dem Hashtag #schnoffle #herbstschnoffle'
            ),
            _react2.default.createElement(
                _InternalLink2.default,
                {
                    to: {
                        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                        payload: {
                            sewpatId: 'pony',
                            patternid: 17986
                        }
                        // meta: { query: { colors: '000000,b44a3f,eccdc4' } },
                    }
                },
                _react2.default.createElement(_CloudFrontPicture2.default, {
                    src: 'hashtag-herbstschnoffle.jpg',
                    webp: 'hashtag-herbstschnoffle.webp', schnoffle: true
                })
            ),
            _react2.default.createElement(_Text2.default.Divider, null),
            _react2.default.createElement(_CurrentHashtagWinner2.default, null),
            _react2.default.createElement(_Text2.default.Divider, null),
            _react2.default.createElement(_Text2.default.Heading, { text: 'Idee', level: 2, png: true }),
            _react2.default.createElement(
                'p',
                null,
                'Quartalsweise suchen wir zu einem Thema das sch\xF6nste Designerst\xFCck. Daf\xFCr gibt es immer eine kurze Geschichte zur Thematik und die entsprechende Jury (erstmal Ellen & Dagmar, sp\xE4ter vielleicht auch Blogger), die den sch\xF6nsten Entwurf aussuchen wird.'
            ),
            _react2.default.createElement(_Text2.default.Heading, { text: 'Wann?', level: 5 }),
            _react2.default.createElement(
                'p',
                null,
                'Immer das erste Wochenende im neuen Quartal wird der Siegbeitrag des vorherigen Quartals gek\xFCrt! Also im Oktober das Quartalsthema Juli/Aug/Sept usw.'
            ),
            _react2.default.createElement(_Text2.default.Heading, { text: 'Wie?', level: 5 }),
            _react2.default.createElement(
                'p',
                null,
                'Jeder gestaltet seinen Lieblingsschnitt im passenden Stoff zum Thema und pinnt diesen mit einem spezifischen #Hashtag bei Pinterest, teilt die Modezeichnung unter Angabe von Schnitt + Stoffdesign bei Instagram oder Facebook.'
            ),
            _react2.default.createElement(_Text2.default.Heading, { text: 'Was?', level: 5 }),
            _react2.default.createElement(
                'p',
                null,
                'Unter allen, die unter dem Hashtag mitmachen, k\xFCrt die Jury den Gewinner.'
            ),
            _react2.default.createElement(_Text2.default.Divider, null),
            _react2.default.createElement(_Text2.default.Heading, { text: 'Themen', level: 4 }),
            _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                    'li',
                    null,
                    'Im April/Mai/Juni - Springflower ',
                    _react2.default.createElement(
                        'span',
                        {
                            className: 'schnoffle-bold'
                        },
                        '#springschnoffle'
                    )
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    'Im Juli/August/September - Bunter Herbst',
                    _react2.default.createElement(
                        'span',
                        {
                            className: 'schnoffle-bold'
                        },
                        '#herbstschnoffle'
                    )
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    'to be continued...'
                )
            ),
            _react2.default.createElement(_Text2.default.Divider, null),
            _react2.default.createElement(
                _CollapsableContainer2.default,
                {
                    heading: 'Hilfe zum Pinnen/Teilen der Modeskizzen'
                },
                _react2.default.createElement(
                    'p',
                    null,
                    'Pinterest: ',
                    _react2.default.createElement(
                        'a',
                        {
                            href: 'https://about.pinterest.com/de/browser-button'
                        },
                        'Mit dem "Pin it" Button geht es mit dem Teilen der eigenen Entw\xFCrfe auf jedem Ger\xE4t super leicht...'
                    )
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    'Modezeichnung einfach per Handy teilen: Einfach das Foto vom Entwurf gedr\xFCckt halten bis die Aufforderung zum "Bild teilen" kommt. Dann auf Facebook, Instagram und/oder Pinterest mit dem Hashtag des Monats so ver\xF6ffentlichen, dass der Post allen zug\xE4nglich ist.'
                ),
                _react2.default.createElement(_CloudFrontPicture2.default, {
                    src: 'schnoffle-teilen.gif', gif: 'schnoffle-teilen.gif',
                    webp: 'schnoffle-teilen.webp', schnoffle: true
                })
            ),
            _react2.default.createElement(
                _CollapsableContainer2.default,
                {
                    heading: 'Teilnahmebedingungen'
                },
                _react2.default.createElement(_Text2.default.Heading, {
                    text: 'Wer veranstaltet das Gewinnspiel?',
                    level: 6
                }),
                _react2.default.createElement(
                    'p',
                    null,
                    'Becker & Karsten UG (haftungsbeschr\xE4nkt),Sandhauser Stra\xDFe 107, 13505 Berlin'
                ),
                _react2.default.createElement(_Text2.default.Heading, { text: 'Wer nimmt teil?', level: 6 }),
                _react2.default.createElement(
                    'p',
                    null,
                    'Jede, die einen Entwurf zum jeweiligen Quartalsthema unter dem jeweiligen Hashtag auf den sozialen Netzwerken Pinterest und Facebook oder Instagram beitr\xE4gt.'
                ),
                _react2.default.createElement(_Text2.default.Heading, {
                    text: 'Wann findet das Gewinnspiel statt?',
                    level: 6
                }),
                _react2.default.createElement(
                    'p',
                    null,
                    'Das Gewinnspiel findet jedes Quartal statt.'
                ),
                _react2.default.createElement(_Text2.default.Heading, { text: 'Was kann ich gewinnen?', level: 6 }),
                _react2.default.createElement(
                    'p',
                    null,
                    'Es kann ein N\xE4hpaket aus Schnitt + selbst gestaltetem Stoff gewonnen werden.'
                ),
                _react2.default.createElement(_Text2.default.Heading, {
                    text: 'Wann und wie wird die Gewinnerin bestimmt?',
                    level: 6
                }),
                _react2.default.createElement(
                    'p',
                    null,
                    'Immer am ersten Sonntag im Quartal wird der Gewinnerbeitrag des vorherigen Quartals durch eine Jury bestimmt.'
                ),
                _react2.default.createElement(_Text2.default.Heading, {
                    text: 'Wie bekomme ich den Gewinn?',
                    level: 6
                }),
                _react2.default.createElement(
                    'p',
                    null,
                    'Wir ver\xF6ffentlichen die Sieger-Modeskizze und einen Link zu dem entsprechenden Post. Wir produzieren den Stoff f\xFCr das N\xE4hpaket nachdem die Gewinnerin durch die Jury gew\xE4hlt wurde und uns die entsprechenden Daten (Name und Anschrift) mitgeteilt hat. Das N\xE4hpaket wird dann nach etwa 3 Wochen an die Gewinnerin versendet.'
                ),
                _react2.default.createElement(_Text2.default.Heading, {
                    text: 'Datenschutz',
                    level: 6
                }),
                _react2.default.createElement(
                    'p',
                    null,
                    'Wir ver\xF6ffentlichen auf https://www.schnoffle.de/hashtag und in den Sozialen Medien die Modeskizze, die gewonnen hat und verlinken den Gewinnerbeitrag in den jeweiligen Sozialen Netzwerken.'
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    'N\xE4heres zum Datenschutz bei uns,',
                    _react2.default.createElement(
                        _InternalLink2.default,
                        {
                            className: 'stolo-footer-link',
                            to: { type: types.NAVIGATED_TO_PRIVACY }
                        },
                        '\xA0findest Du hier.'
                    )
                )
            ),
            _react2.default.createElement(
                _CollapsableContainer2.default,
                {
                    heading: 'Datenschutz'
                },
                _react2.default.createElement(_Text2.default.Heading, { text: 'Datenschutz bei Schnoffle?', level: 6 }),
                _react2.default.createElement(
                    'p',
                    null,
                    'Die Informationen zum Datenschutz bei der Becker & Karsten UG (haftungsbeschr\xE4nkt), Sandhauser Stra\xDFe 107, 13505 Berlin, ',
                    _react2.default.createElement(
                        _InternalLink2.default,
                        {
                            className: 'stolo-footer-link',
                            to: { type: types.NAVIGATED_TO_PRIVACY }
                        },
                        'kannst Du hier lesen'
                    )
                ),
                _react2.default.createElement(_Text2.default.Heading, { text: 'Datenschutz Instagram', level: 6 }),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                        'a',
                        {
                            href: 'https://help.instagram.com/519522125107875?helpref=page_content'
                        },
                        'Instagram-Datenschutzrichtlinie'
                    )
                ),
                _react2.default.createElement(_Text2.default.Heading, { text: 'Datenschutz Facebook', level: 6 }),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                        'a',
                        { href: 'https://de-de.facebook.com/policy.php' },
                        'Facebook Datenrichtlinie'
                    )
                ),
                _react2.default.createElement(_Text2.default.Heading, { text: 'Datenschutz Pinterest', level: 6 }),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(
                        'a',
                        { href: 'https://policy.pinterest.com/de/privacy-policy' },
                        'Pinterest Datenschutz'
                    )
                )
            ),
            _react2.default.createElement(_HashtagWinnerHistory2.default, null)
        )
    );
};

exports.default = Hashtag;

/***/ }),

/***/ "ExK/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Picture = function Picture(_ref) {
    var src = _ref.src,
        webp = _ref.webp,
        altText = _ref.altText,
        png = _ref.png,
        gif = _ref.gif;

    var StyledImage = _styledComponents2.default.img.withConfig({
        displayName: 'Picture__StyledImage',
        componentId: 'sc-sjj3zq-0'
    })(['\n        height: auto;\n        width: auto;\n        max-width: 100%;\n    ']);

    return _react2.default.createElement(
        'picture',
        null,
        webp ? _react2.default.createElement('source', { srcSet: webp, type: 'image/webp' }) : null,
        gif ? _react2.default.createElement('source', { srcSet: gif, type: 'image/gif' }) : null,
        _react2.default.createElement(StyledImage, { src: src, alt: altText || 'image' })
    );
};

exports.default = Picture;

/***/ }),

/***/ "L4iW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Paper.default;
  }
});

var _Paper = _interopRequireDefault(__webpack_require__("P4HR"));

/***/ }),

/***/ "MTmj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _actionTypes = __webpack_require__("EA8k");

var types = _interopRequireWildcard(_actionTypes);

var _Text = __webpack_require__("8/ml");

var _Text2 = _interopRequireDefault(_Text);

var _CloudFrontPicture = __webpack_require__("k6iV");

var _CloudFrontPicture2 = _interopRequireDefault(_CloudFrontPicture);

var _InternalLink = __webpack_require__("XSs2");

var _InternalLink2 = _interopRequireDefault(_InternalLink);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurrentHashtagWinner = function CurrentHashtagWinner() {
    var StyledCurrentHashtagWinner = _styledComponents2.default.div.withConfig({
        displayName: 'HashtagWinnerHistory__StyledCurrentHashtagWinner',
        componentId: 'sc-bvt60v-0'
    })(['\n        &.schnoffle-hashtag-winner img {\n          max-heigth: 60vh;\n          max-width: 60vw;\n        }\n\n        & .schnoffle-hashtag-winner-text {\n          margin-bottom: 2em;\n        }\n    ']);

    return _react2.default.createElement(
        StyledCurrentHashtagWinner,
        { className: 'schnoffle-hashtag-winner' },
        _react2.default.createElement(_Text2.default.Heading, {
            text: 'Unsere Gewinner',
            level: 3
        }),
        _react2.default.createElement(_Text2.default.Heading, {
            text: 'Gewinnerin Juni 2019',
            level: 3
        }),
        _react2.default.createElement(
            _InternalLink2.default,
            {
                to: {
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'mia',
                        patternid: 22485
                    }
                    // meta: { query: { colors: '000000,b44a3f,eccdc4' } },
                }
            },
            _react2.default.createElement(_CloudFrontPicture2.default, {
                src: 'hashtag-springschnoffle.jpg',
                webp: 'hashtag-springschnoffle.webp', schnoffle: true
            })
        ),
        _react2.default.createElement(
            'p',
            { className: 'schnoffle-hashtag-winner-text' },
            _react2.default.createElement(
                _InternalLink2.default,
                {
                    to: {
                        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                        payload: {
                            sewpatId: 'martha',
                            patternid: 24472
                        },
                        meta: { query: { colors: '000000,ffffff,4c4c4d,5c9dc0,5174ef,5bc5c6' } }
                    }
                },
                'Dieser Entwurf\xA0'
            ),
            'des Designerst\xFCckes ',
            _react2.default.createElement(
                _InternalLink2.default,
                {
                    to: {
                        type: types.NAVIGATED_TO_SEWPAT_VIEW,
                        payload: { sewpatId: 'martha' }
                    }
                },
                '"Martha"\xA0'
            ),
            'eingereicht von ',
            _react2.default.createElement(
                'a',
                {
                    href: 'https://www.facebook.com/FarbTuepfelchen/posts/2410162472546984'
                },
                'Carina aka Kleines Farb - Tupferl'
            ),
            ', gewinnt die Junirunde des #schnoffle Hashtag Wettbewerbs #springschnoffle.'
        ),
        _react2.default.createElement(
            _InternalLink2.default,
            {
                to: {
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'martha',
                        patternid: 24472
                    },
                    meta: { query: { colors: '000000,ffffff,4c4c4d,5c9dc0,5174ef,5bc5c6' } }
                }
            },
            _react2.default.createElement(_CloudFrontPicture2.default, {
                src: 'schnoffle-gewinner-q2-19.png',
                webp: 'sschnoffle-gewinner-q2-19.webp', png: true, schnoffle: true
            })
        ),
        _react2.default.createElement(_Text2.default.Divider, null),
        _react2.default.createElement(_Text2.default.Heading, {
            text: 'M\xE4rz 2019',
            level: 3
        }),
        _react2.default.createElement(
            _InternalLink2.default,
            {
                to: {
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'liv',
                        patternid: 22084
                    }
                    // meta: { query: { colors: '000000,b44a3f,eccdc4' } },
                }
            },
            _react2.default.createElement(_CloudFrontPicture2.default, {
                src: '2019-01-60erschnoffle.png',
                webp: '2019-01-60erschnoffle.webp', png: true, schnoffle: true
            })
        ),
        _react2.default.createElement(
            'p',
            { className: 'schnoffle-hashtag-winner-text' },
            _react2.default.createElement(
                _InternalLink2.default,
                {
                    to: {
                        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                        payload: {
                            sewpatId: 'edda',
                            patternid: 23378
                        },
                        meta: { query: { colors: '1c8c80,8d2e98,fccdd1' } }
                    }
                },
                'Dieser Entwurf\xA0'
            ),
            'des Designerst\xFCckes ',
            _react2.default.createElement(
                _InternalLink2.default,
                {
                    to: {
                        type: types.NAVIGATED_TO_SEWPAT_VIEW,
                        payload: { sewpatId: 'edda' }
                    }
                },
                '"EDDA"\xA0'
            ),
            'eingereicht von ',
            _react2.default.createElement(
                'a',
                {
                    href: 'https://www.instagram.com/p/Bt3o9SFHl38/'
                },
                'Marietta'
            ),
            ', gewinnt die M\xE4rzrunde des #schnoffle Hashtag Wettbewerbs #6oerschnoffle.'
        ),
        _react2.default.createElement(
            _InternalLink2.default,
            {
                to: {
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'edda',
                        patternid: 23378
                    },
                    meta: { query: { colors: '1c8c80,8d2e98,fccdd1' } }
                }
            },
            _react2.default.createElement(_CloudFrontPicture2.default, {
                src: 'schnoffle-gewinner-q1-19.png',
                webp: 'sschnoffle-gewinner-q1-19.webp', png: true, schnoffle: true
            })
        ),
        _react2.default.createElement(_Text2.default.Divider, null),
        _react2.default.createElement(_Text2.default.Heading, {
            text: 'Dezember 2018',
            level: 3
        }),
        _react2.default.createElement(
            _InternalLink2.default,
            {
                to: {
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: { sewpatId: 'pony', patternid: 20404 }
                    // meta: { query: { colors: '000000,b44a3f,eccdc4' } },
                }
            },
            _react2.default.createElement(_CloudFrontPicture2.default, {
                src: 'dezember-blackandwhiteschnoffle.png',
                webp: 'dezember-blackandwhiteschnoffle', png: true, schnoffle: true
            })
        ),
        _react2.default.createElement(
            'p',
            { className: 'schnoffle-hashtag-winner-text' },
            _react2.default.createElement(
                _InternalLink2.default,
                {
                    to: {
                        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                        payload: {
                            sewpatId: 'pony',
                            patternid: 20404
                        },
                        meta: { query: { colors: 'ffffff,000000' } }
                    }
                },
                'Dieser Entwurf\xA0'
            ),
            'des Designerst\xFCckes ',
            _react2.default.createElement(
                _InternalLink2.default,
                {
                    to: {
                        type: types.NAVIGATED_TO_SEWPAT_VIEW,
                        payload: { sewpatId: 'pony' }
                    }
                },
                '"Pony"\xA0'
            ),
            'eingereicht von ',
            _react2.default.createElement(
                'a',
                {
                    href: 'https://www.pinterest.de/pin/815010863793088838/'
                },
                'Andrea Albrecht'
            ),
            ', gewinnt die Dezemberrunde des #schnoffle Hashtag Wettbewerbs #blackandwhiteschnoffle.'
        ),
        _react2.default.createElement(
            _InternalLink2.default,
            {
                to: {
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'pony',
                        patternid: 20404
                    },
                    meta: { query: { colors: 'ffffff,000000' } }
                }
            },
            _react2.default.createElement(_CloudFrontPicture2.default, {
                src: 'schnoffle-winner-12-18.png',
                webp: 'sschnoffle-winner-12-18.webp', png: true, schnoffle: true
            })
        ),
        _react2.default.createElement(_Text2.default.Divider, null),
        _react2.default.createElement(_Text2.default.Heading, {
            text: 'November 2018',
            level: 3
        }),
        _react2.default.createElement(
            _InternalLink2.default,
            {
                to: {
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: { sewpatId: 'martha', patternid: 824 },
                    meta: { query: { colors: '000000,b44a3f,eccdc4' } }
                }
            },
            _react2.default.createElement(_CloudFrontPicture2.default, {
                src: 'november-adventschnoffle.png',
                webp: 'november-adventschnoffle', png: true, schnoffle: true
            })
        ),
        _react2.default.createElement(
            'p',
            { className: 'schnoffle-hashtag-winner-text' },
            _react2.default.createElement(
                _InternalLink2.default,
                {
                    to: {
                        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                        payload: {
                            sewpatId: 'liv',
                            patternid: 2549
                        },
                        meta: { query: { colors: '111314,5e4d33,ffffff' } }
                    }
                },
                'Dieser Entwurf\xA0'
            ),
            'des Designerst\xFCckes ',
            _react2.default.createElement(
                _InternalLink2.default,
                {
                    to: {
                        type: types.NAVIGATED_TO_SEWPAT_VIEW,
                        payload: { sewpatId: 'liv' }
                    }
                },
                '"Liv"\xA0'
            ),
            'eingereicht von ',
            _react2.default.createElement(
                'a',
                {
                    href: 'https://www.facebook.com/FarbTuepfelchen/photos/a.1739331306296774/2263861993843700/'
                },
                'Carina We (Kleines FarbTupferl)'
            ),
            ', gewinnt die Novemberrunde des #schnoffle Hashtag Wettbewerbs #adventschnoffle.'
        ),
        _react2.default.createElement(
            _InternalLink2.default,
            {
                to: {
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'liv',
                        patternid: 2549
                    },
                    meta: { query: { colors: '111314,5e4d33,ffffff' } }
                }
            },
            _react2.default.createElement(_CloudFrontPicture2.default, {
                src: 'schnoffle-winner-11-18.png',
                webp: 'sschnoffle-winner-11-18.webp', png: true, schnoffle: true
            })
        ),
        _react2.default.createElement(_Text2.default.Divider, null),
        _react2.default.createElement(_Text2.default.Heading, {
            text: 'Oktober 2018',
            level: 3
        }),
        _react2.default.createElement(
            _InternalLink2.default,
            {
                to: {
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'paula',
                        patternid: 4643
                    }
                }
            },
            _react2.default.createElement(_CloudFrontPicture2.default, {
                src: 'oktober-forestschnoffle.png',
                webp: 'oktober-forestschnoffle', png: true, schnoffle: true
            })
        ),
        _react2.default.createElement(
            'p',
            { className: 'schnoffle-hashtag-winner-text' },
            _react2.default.createElement(
                _InternalLink2.default,
                {
                    to: {
                        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                        payload: {
                            sewpatId: 'lilly',
                            patternid: 20625
                        },
                        meta: { query: { colors: '6d7e46,cf905c,e6e4cc,2e1804' } }
                    }
                },
                'Dieser Entwurf\xA0'
            ),
            'des Designerst\xFCckes ',
            _react2.default.createElement(
                _InternalLink2.default,
                {
                    to: {
                        type: types.NAVIGATED_TO_SEWPAT_VIEW,
                        payload: { sewpatId: 'lilly' }
                    }
                },
                '"Lilly"\xA0'
            ),
            'eingereicht von ',
            _react2.default.createElement(
                'a',
                {
                    href: 'https://www.pinterest.de/pin/815010863792282930/'
                },
                'Andrea Albrecht'
            ),
            ', gewinnt die Oktoberrunde des #schnoffle Hashtag Wettbewerbs #forestschnoffle.'
        ),
        _react2.default.createElement(
            _InternalLink2.default,
            {
                to: {
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'lilly',
                        patternid: 20625
                    },
                    meta: { query: { colors: '6d7e46,cf905c,e6e4cc,2e1804' } }
                }
            },
            _react2.default.createElement(_CloudFrontPicture2.default, {
                src: 'schnoffle-winner-10-18.png',
                webp: 'sschnoffle-winner-10-18.webp', png: true, schnoffle: true
            })
        ),
        _react2.default.createElement(_Text2.default.Divider, null),
        _react2.default.createElement(_Text2.default.Heading, {
            text: 'September 2018',
            level: 5
        }),
        _react2.default.createElement(
            _InternalLink2.default,
            {
                to: {
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'lina',
                        patternid: 3489
                    }
                }
            },
            _react2.default.createElement(_CloudFrontPicture2.default, {
                src: 'september-paisleyschnoffle.png',
                webp: 'september-paisleychnoffle', png: true, schnoffle: true
            })
        ),
        _react2.default.createElement(
            'p',
            { className: 'schnoffle-hashtag-winner-text' },
            _react2.default.createElement(
                _InternalLink2.default,
                {
                    to: {
                        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                        payload: {
                            sewpatId: 'martha',
                            patternid: 3489
                        },
                        meta: { query: { colors: 'a993bd,523171,8841ca,8c65b1,3c294e,5c4c6b,ba9fd4,28222d,6e5387,8a6da5,985cd2,9c7bbc,ac8fc7' } }
                    }
                },
                'Dieser Entwurf\xA0'
            ),
            'des Designerst\xFCckes ',
            _react2.default.createElement(
                _InternalLink2.default,
                {
                    to: {
                        type: types.NAVIGATED_TO_SEWPAT_VIEW,
                        payload: { sewpatId: 'martha' }
                    }
                },
                '"Martha"\xA0'
            ),
            'eingereicht von ',
            _react2.default.createElement(
                'a',
                {
                    href: 'https://www.pinterest.com/pin/580401470704790154/'
                },
                'Birgit Elmrich'
            ),
            ', gewinnt die Septemberrunde des #schnoffle Hashtag Wettbewerbs #paisleyschnoffle.'
        ),
        _react2.default.createElement(
            _InternalLink2.default,
            {
                to: {
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'martha',
                        patternid: 3489
                    },
                    meta: { query: { colors: 'a993bd,523171,8841ca,8c65b1,3c294e,5c4c6b,ba9fd4,28222d,6e5387,8a6da5,985cd2,9c7bbc,ac8fc7' } }
                }
            },
            _react2.default.createElement(_CloudFrontPicture2.default, {
                src: 'schnoffle-winner-09-18.png',
                webp: 'schnoffle-winner-09-18', png: true, schnoffle: true
            })
        ),
        _react2.default.createElement(_Text2.default.Divider, null),
        _react2.default.createElement(_Text2.default.Heading, {
            text: 'August 2018',
            level: 5
        }),
        _react2.default.createElement(
            _InternalLink2.default,
            {
                to: {
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'liv',
                        patternid: 17499
                    }
                }
            },
            _react2.default.createElement(_CloudFrontPicture2.default, {
                src: 'august-betaschnoffle.png',
                webp: 'august-betaschnoffle', png: true, schnoffle: true
            })
        ),
        _react2.default.createElement(
            'p',
            { className: 'schnoffle-hashtag-winner-text' },
            _react2.default.createElement(
                _InternalLink2.default,
                {
                    to: {
                        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                        payload: {
                            sewpatId: 'liv',
                            patternid: 10882
                        },
                        meta: { query: { colors: '6e2d40,181818,Cc7a2ab,ffffff,000000' } }
                    }
                },
                'Dieser Entwurf\xA0'
            ),
            'des Designerst\xFCckes ',
            _react2.default.createElement(
                _InternalLink2.default,
                {
                    to: {
                        type: types.NAVIGATED_TO_SEWPAT_VIEW,
                        payload: { sewpatId: 'liv' }
                    }
                },
                '"Liv"\xA0'
            ),
            'eingereicht von ',
            _react2.default.createElement(
                'a',
                {
                    href: ' https://www.instagram.com/p/BmnNJ7hDQhe/'
                },
                'ebomil'
            ),
            ', gewinnt die Augustrunde des #schnoffle Hashtag Wettbewerbs #betaschnoffle.'
        ),
        _react2.default.createElement(
            _InternalLink2.default,
            {
                to: {
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'liv',
                        patternid: 10882
                    },
                    meta: { query: { colors: '6e2d40,181818,Cc7a2ab,ffffff,000000' } }
                }
            },
            _react2.default.createElement(_CloudFrontPicture2.default, {
                src: 'schnoffle-winner-0.png',
                webp: 'schnoffle-winner-0', png: true, schnoffle: true
            })
        )
    );
};

exports.default = CurrentHashtagWinner;

/***/ }),

/***/ "NfTG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("HBRR"));

var _createClass2 = _interopRequireDefault(__webpack_require__("ud+X"));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__("rjj8"));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__("X+J+"));

var _inherits2 = _interopRequireDefault(__webpack_require__("ymoH"));

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _warning = _interopRequireDefault(__webpack_require__("mG8X"));

var _Collapse = _interopRequireDefault(__webpack_require__("ufiz"));

var _Paper = _interopRequireDefault(__webpack_require__("L4iW"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var _reactHelpers = __webpack_require__("ToDL");

// @inheritedComponent Paper
// Workaround https://github.com/jsdom/jsdom/issues/2026
var edgeFix = typeof window !== 'undefined' && /jsdom/.test(window.navigator.userAgent) ? {} : {
  // Fix a rendering issue on Edge
  '@supports (-ms-ime-align: auto)': {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  }
};

var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-child': {
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
        '&:before': {
          display: 'none'
        }
      },
      '&:last-child': (0, _extends2.default)({
        borderBottomLeftRadius: 2,
        borderBottomRightRadius: 2
      }, edgeFix),
      '&$expanded + &': {
        '&:before': {
          display: 'none'
        }
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {
      margin: '16px 0',
      '&:first-child': {
        marginTop: 0
      },
      '&:last-child': {
        marginBottom: 0
      },
      '&:before': {
        opacity: 0
      }
    },

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {
      backgroundColor: theme.palette.action.disabledBackground
    }
  };
};

exports.styles = styles;

var ExpansionPanel =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ExpansionPanel, _React$Component);

  function ExpansionPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ExpansionPanel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ExpansionPanel).call(this));
    _this.isControlled = null;
    _this.state = {};

    _this.handleChange = function (event) {
      var expanded = _this.isControlled ? _this.props.expanded : _this.state.expanded;

      if (!_this.isControlled) {
        _this.setState({
          expanded: !expanded
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event, !expanded);
      }
    };

    _this.isControlled = props.expanded != null;

    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.expanded = props.defaultExpanded !== undefined ? props.defaultExpanded : false;
    }

    return _this;
  }

  (0, _createClass2.default)(ExpansionPanel, [{
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props = this.props,
          childrenProp = _this$props.children,
          classes = _this$props.classes,
          classNameProp = _this$props.className,
          CollapsePropsProp = _this$props.CollapseProps,
          defaultExpanded = _this$props.defaultExpanded,
          disabled = _this$props.disabled,
          expandedProp = _this$props.expanded,
          onChange = _this$props.onChange,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "classes", "className", "CollapseProps", "defaultExpanded", "disabled", "expanded", "onChange"]);
      var expanded = this.isControlled ? expandedProp : this.state.expanded;
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.expanded, expanded), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp);
      var summary = null;

      var children = _react.default.Children.map(childrenProp, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the ExpansionPanel component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;

        if ((0, _reactHelpers.isMuiElement)(child, ['ExpansionPanelSummary'])) {
          summary = _react.default.cloneElement(child, {
            disabled: disabled,
            expanded: expanded,
            onChange: _this2.handleChange
          });
          return null;
        }

        return child;
      });

      var CollapseProps = !expanded ? {
        'aria-hidden': 'true'
      } : null;
      return _react.default.createElement(_Paper.default, (0, _extends2.default)({
        className: className,
        elevation: 1,
        square: true
      }, other), summary, _react.default.createElement(_Collapse.default, (0, _extends2.default)({
        in: expanded,
        timeout: "auto"
      }, CollapseProps, CollapsePropsProp), children));
    }
  }]);
  return ExpansionPanel;
}(_react.default.Component);

ExpansionPanel.propTypes =  false ? {
  /**
   * The content of the expansion panel.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Properties applied to the [`Collapse`](/api/collapse) element.
   */
  CollapseProps: _propTypes.default.object,

  /**
   * If `true`, expands the panel by default.
   */
  defaultExpanded: _propTypes.default.bool,

  /**
   * If `true`, the panel will be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, expands the panel, otherwise collapse it.
   * Setting this prop enables control over the panel.
   */
  expanded: _propTypes.default.bool,

  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} expanded The `expanded` state of the panel
   */
  onChange: _propTypes.default.func
} : {};
ExpansionPanel.defaultProps = {
  defaultExpanded: false,
  disabled: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanel'
})(ExpansionPanel);

exports.default = _default;

/***/ }),

/***/ "OYRJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanelSummary.default;
  }
});

var _ExpansionPanelSummary = _interopRequireDefault(__webpack_require__("Rgnr"));

/***/ }),

/***/ "P4HR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _warning = _interopRequireDefault(__webpack_require__("mG8X"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0, _extends2.default)({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    }
  }, elevations);
};

exports.styles = styles;

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Paper.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes.default.number,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes.default.bool
} : {};
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPaper'
})(Paper);

exports.default = _default;

/***/ }),

/***/ "Rgnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("HBRR"));

var _createClass2 = _interopRequireDefault(__webpack_require__("ud+X"));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__("rjj8"));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__("X+J+"));

var _inherits2 = _interopRequireDefault(__webpack_require__("ymoH"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _ButtonBase = _interopRequireDefault(__webpack_require__("32DM"));

var _IconButton = _interopRequireDefault(__webpack_require__("q/an"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      minHeight: 8 * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: '0 24px 0 24px',
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      },
      '&$expanded': {
        minHeight: 64
      },
      '&$focused': {
        backgroundColor: theme.palette.grey[300]
      },
      '&$disabled': {
        opacity: 0.38
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {},

    /* Styles applied to the root and children wrapper elements when focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children wrapper element. */
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '& > :last-child': {
        paddingRight: 32
      },
      '&$expanded': {
        margin: '20px 0'
      }
    },

    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
      position: 'absolute',
      top: '50%',
      right: 8,
      transform: 'translateY(-50%) rotate(0deg)',
      transition: theme.transitions.create('transform', transition),
      '&:hover': {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: 'transparent'
      },
      '&$expanded': {
        transform: 'translateY(-50%) rotate(180deg)'
      }
    }
  };
};

exports.styles = styles;

var ExpansionPanelSummary =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ExpansionPanelSummary, _React$Component);

  function ExpansionPanelSummary() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ExpansionPanelSummary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ExpansionPanelSummary)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      focused: false
    };

    _this.handleFocus = function () {
      _this.setState({
        focused: true
      });
    };

    _this.handleBlur = function () {
      _this.setState({
        focused: false
      });
    };

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onClick = _this$props.onClick;

      if (onChange) {
        onChange(event);
      }

      if (onClick) {
        onClick(event);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(ExpansionPanelSummary, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          children = _this$props2.children,
          classes = _this$props2.classes,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          expanded = _this$props2.expanded,
          expandIcon = _this$props2.expandIcon,
          IconButtonProps = _this$props2.IconButtonProps,
          onChange = _this$props2.onChange,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "classes", "className", "disabled", "expanded", "expandIcon", "IconButtonProps", "onChange"]);
      var focused = this.state.focused;
      return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.expanded, expanded), (0, _defineProperty2.default)(_classNames, classes.focused, focused), _classNames), className)
      }, other, {
        onFocusVisible: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleChange
      }), _react.default.createElement("div", {
        className: (0, _classnames.default)(classes.content, (0, _defineProperty2.default)({}, classes.expanded, expanded))
      }, children), expandIcon && _react.default.createElement(_IconButton.default, (0, _extends2.default)({
        disabled: disabled,
        className: (0, _classnames.default)(classes.expandIcon, (0, _defineProperty2.default)({}, classes.expanded, expanded)),
        component: "div",
        tabIndex: -1,
        "aria-hidden": "true"
      }, IconButtonProps), expandIcon));
    }
  }]);
  return ExpansionPanelSummary;
}(_react.default.Component);

ExpansionPanelSummary.propTypes =  false ? {
  /**
   * The content of the expansion panel summary.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   * If `true`, the summary will be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   * If `true`, expands the summary, otherwise collapse it.
   */
  expanded: _propTypes.default.bool,

  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: _propTypes.default.node,

  /**
   * Properties applied to the `TouchRipple` element wrapping the expand icon.
   */
  IconButtonProps: _propTypes.default.object,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func
} : {};
ExpansionPanelSummary.defaultProps = {
  disabled: false
};
ExpansionPanelSummary.muiName = 'ExpansionPanelSummary';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanelSummary'
})(ExpansionPanelSummary);

exports.default = _default;

/***/ }),

/***/ "SZDM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.hr.withConfig({
    displayName: 'HorizontalDivider',
    componentId: 'sc-2e8hns-0'
})(['\n    border: 0;\n    height: 1px;\n    background-image: linear-gradient(to right, rgba(69, 90, 100, 0.05), rgba(69, 90, 100, 0.5), rgba(69, 90, 100, 0.05));\n    margin: ', ';\n    clear: both;\n    overflow: hidden;\n'], function (props) {
    return props.margin ? props.margin : '2em 0 1em';
});

/***/ }),

/***/ "T1RF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransitionProps = getTransitionProps;
exports.reflow = void 0;

var reflow = function reflow(node) {
  return node.scrollTop;
};

exports.reflow = reflow;

function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode],
    delay: style.transitionDelay
  };
}

/***/ }),

/***/ "ToDL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneElementWithClassName = cloneElementWithClassName;
exports.cloneChildrenWithClassName = cloneChildrenWithClassName;
exports.isMuiElement = isMuiElement;
exports.isMuiComponent = isMuiComponent;

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

/* eslint-disable import/prefer-default-export */
function cloneElementWithClassName(child, className) {
  return _react.default.cloneElement(child, {
    className: (0, _classnames.default)(child.props.className, className)
  });
}

function cloneChildrenWithClassName(children, className) {
  return _react.default.Children.map(children, function (child) {
    return _react.default.isValidElement(child) && cloneElementWithClassName(child, className);
  });
}

function isMuiElement(element, muiNames) {
  return _react.default.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function isMuiComponent(element, muiNames) {
  return muiNames.indexOf(element.muiName) !== -1;
}

/***/ }),

/***/ "fRaP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var _colorManipulator = __webpack_require__("1wwW");

var _ButtonBase = _interopRequireDefault(__webpack_require__("32DM"));

var _helpers = __webpack_require__("QbVD");

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      width: 48,
      height: 48,
      padding: 0,
      borderRadius: '50%',
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/style/icons) section of the documentation
 * regarding the available icon options.
 */


exports.styles = styles;

function IconButton(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      disabled = props.disabled,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled"]);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), className),
    centerRipple: true,
    focusRipple: true,
    disabled: disabled
  }, other), _react.default.createElement("span", {
    className: classes.label
  }, children));
}

IconButton.propTypes =  false ? {
  /**
   * The icon element.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple will be disabled.
   */
  disableRipple: _propTypes.default.bool
} : {};
IconButton.defaultProps = {
  color: 'default',
  disabled: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiIconButton'
})(IconButton);

exports.default = _default;

/***/ }),

/***/ "hbe8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__("HBRR"));

var _createClass2 = _interopRequireDefault(__webpack_require__("ud+X"));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__("rjj8"));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__("X+J+"));

var _inherits2 = _interopRequireDefault(__webpack_require__("ymoH"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _Transition = _interopRequireDefault(__webpack_require__("TAxY"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var _transitions = __webpack_require__("z+QM");

var _utils = __webpack_require__("T1RF");

// @inheritedComponent Transition
var styles = function styles(theme) {
  return {
    /* Styles applied to the container element. */
    container: {
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    },

    /* Styles applied to the container element when the transition has entered. */
    entered: {
      height: 'auto'
    },

    /* Styles applied to the outer wrapper element. */
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex'
    },

    /* Styles applied to the outer wrapper element. */
    wrapperInner: {
      width: '100%'
    }
  };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/demos/steppers#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */


exports.styles = styles;

var Collapse =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Collapse, _React$Component);

  function Collapse() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Collapse);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Collapse)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.wrapper = null;
    _this.autoTransitionDuration = null;
    _this.timer = null;

    _this.handleEnter = function (node) {
      node.style.height = _this.props.collapsedHeight;

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleEntering = function (node) {
      var _this$props = _this.props,
          timeout = _this$props.timeout,
          theme = _this$props.theme;
      var wrapperHeight = _this.wrapperRef ? _this.wrapperRef.clientHeight : 0;

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration;

      if (timeout === 'auto') {
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
        node.style.transitionDuration = "".concat(duration2, "ms");
        _this.autoTransitionDuration = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
      }

      node.style.height = "".concat(wrapperHeight, "px");

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    };

    _this.handleEntered = function (node) {
      node.style.height = 'auto';

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    };

    _this.handleExit = function (node) {
      var wrapperHeight = _this.wrapperRef ? _this.wrapperRef.clientHeight : 0;
      node.style.height = "".concat(wrapperHeight, "px");

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.handleExiting = function (node) {
      var _this$props2 = _this.props,
          timeout = _this$props2.timeout,
          theme = _this$props2.theme;
      var wrapperHeight = _this.wrapperRef ? _this.wrapperRef.clientHeight : 0;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration;

      if (timeout === 'auto') {
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
        node.style.transitionDuration = "".concat(duration2, "ms");
        _this.autoTransitionDuration = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
      }

      node.style.height = _this.props.collapsedHeight;

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.addEndListener = function (_, next) {
      if (_this.props.timeout === 'auto') {
        _this.timer = setTimeout(next, _this.autoTransitionDuration || 0);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Collapse, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          classes = _this$props3.classes,
          className = _this$props3.className,
          collapsedHeight = _this$props3.collapsedHeight,
          Component = _this$props3.component,
          onEnter = _this$props3.onEnter,
          onEntered = _this$props3.onEntered,
          onEntering = _this$props3.onEntering,
          onExit = _this$props3.onExit,
          onExiting = _this$props3.onExiting,
          style = _this$props3.style,
          theme = _this$props3.theme,
          timeout = _this$props3.timeout,
          other = (0, _objectWithoutProperties2.default)(_this$props3, ["children", "classes", "className", "collapsedHeight", "component", "onEnter", "onEntered", "onEntering", "onExit", "onExiting", "style", "theme", "timeout"]);
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        onEnter: this.handleEnter,
        onEntered: this.handleEntered,
        onEntering: this.handleEntering,
        onExit: this.handleExit,
        onExiting: this.handleExiting,
        addEndListener: this.addEndListener,
        timeout: timeout === 'auto' ? null : timeout
      }, other), function (state, childProps) {
        return _react.default.createElement(Component, (0, _extends2.default)({
          className: (0, _classnames.default)(classes.container, (0, _defineProperty2.default)({}, classes.entered, state === 'entered'), className),
          style: (0, _extends2.default)({}, style, {
            minHeight: collapsedHeight
          })
        }, childProps), _react.default.createElement("div", {
          className: classes.wrapper,
          ref: function ref(_ref) {
            _this2.wrapperRef = _ref;
          }
        }, _react.default.createElement("div", {
          className: classes.wrapperInner
        }, children)));
      });
    }
  }]);
  return Collapse;
}(_react.default.Component);

Collapse.propTypes =  false ? {
  /**
   * The content node to be collapsed.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The height of the container when collapsed.
   */
  collapsedHeight: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onEntered: _propTypes.default.func,

  /**
   * @ignore
   */
  onEntering: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  onExiting: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : {};
Collapse.defaultProps = {
  collapsedHeight: '0px',
  component: 'div',
  timeout: _transitions.duration.standard
};
Collapse.muiSupportAuto = true;

var _default = (0, _withStyles.default)(styles, {
  withTheme: true,
  name: 'MuiCollapse'
})(Collapse);

exports.default = _default;

/***/ }),

/***/ "k6iV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _Picture = __webpack_require__("ExK/");

var _Picture2 = _interopRequireDefault(_Picture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloudFrontPicture = function CloudFrontPicture(_ref) {
    var src = _ref.src,
        webp = _ref.webp,
        gif = _ref.gif,
        altText = _ref.altText,
        png = _ref.png,
        schnoffle = _ref.schnoffle,
        _ref$path = _ref.path,
        path = _ref$path === undefined ? 'images' : _ref$path,
        noQuery = _ref.noQuery;

    var queryString = noQuery ? '' : '?x-schnoffle-request=gallery';
    var base = schnoffle ? 'https://d1hifgxwzqc0jz.cloudfront.net/' + path + '/' : 'https://dd2k02hhj0n6fcf.cloudfront.net/' + path + '/';
    var webpSource = webp ? base + webp + queryString : null;
    var imgSource = src ? base + src + queryString : null;
    var gifSource = gif ? base + gif + queryString : null;

    return _react2.default.createElement(_Picture2.default, {
        webp: webpSource, gif: gifSource, src: imgSource, altText: altText,
        png: png
    });
};

exports.default = CloudFrontPicture;

/***/ }),

/***/ "nR/d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanelDetails.default;
  }
});

var _ExpansionPanelDetails = _interopRequireDefault(__webpack_require__("/rEa"));

/***/ }),

/***/ "q/an":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _IconButton.default;
  }
});

var _IconButton = _interopRequireDefault(__webpack_require__("fRaP"));

/***/ }),

/***/ "u49v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanel.default;
  }
});

var _ExpansionPanel = _interopRequireDefault(__webpack_require__("NfTG"));

/***/ }),

/***/ "ufiz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Collapse.default;
  }
});

var _Collapse = _interopRequireDefault(__webpack_require__("hbe8"));

/***/ }),

/***/ "xFfy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Hashtag = __webpack_require__("EXt7");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hashtag).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ })

});


// WEBPACK FOOTER //
// async/Hashtag.e1f61e78a17d40bbdf0c.js